import { Injectable } from '@angular/core';
import { PlessHttp } from 'src/app/shared/http/pless-http.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessDialogServiceSub } from 'src/app/commons/kymw00/pless-dialog-service-sub';
import { KYMW7400Model } from '../kymw7400.model';

/**
 * 忘れず注文商品情報確定サービス
 * @export ConfirmRememberGoodsService
 * @class ConfirmRememberGoodsService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class ConfirmRememberGoodsService extends PlessJsonResponderSub<any> {
  model: KYMW7400Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof ConfirmRememberGoodsService
   */
  private getBody(): PlessRequest {
    return new PlessRequest(null);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof ConfirmRememberGoodsService
   */
  execute(model: KYMW7400Model, successFunc: Function = null): void {
    this.model = model;
    this.successFunc = successFunc;
    this.send('confirmRememberGoods', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof ConfirmRememberGoodsService
   */
  success(data: any) {
    if (this.successFunc) {
      this.successFunc();
    }
  }

}
